export const typeListen = [
    {value: "restaurant", name: "Restaurant"},
    {value: "hairdressing_salon", name: "Hairdressing salon"},
    {value: "gas_station", name: "Gas station"},
    {value: "auto_repair_shop", name: "Auto repair shop"},
    {value: "pharmacy", name: "Pharmacy"},
    {value: "tailoring_studio", name: "Tailoring studio"},
    {value: "bath_sauna", name: "Bath, sauna"},
    {value: "bowling", name: "Bowling"},
    {value: "bakery", name: "Bakery"},
    {value: "pet_shop", name: "Pet Shop"},
    {value: "store", name: "Store"}
];

export const typeListde = [
    {value: "restaurant", name: "Restaurant"},
    {value: "hairdressing_salon", name: "Friseur"},
    {value: "gas_station", name: "Tankstelle"},
    {value: "auto_repair_shop", name: "Auto-Werkstatt"},
    {value: "pharmacy", name: "Apotheke"},
    {value: "tailoring_studio", name: "Schneiderei"},
    {value: "bath_sauna", name: "Bad, Sauna"},
    {value: "bowling", name: "Bowling"},
    {value: "bakery", name: "Bäckerei"},
    {value: "pet_shop", name: "Tierhandlung"},
    {value: "store", name: "Einkaufen"}
];